/**
 * @author        david.loehr@zumper.com (David Loehr)
 * @copyright     Copyright (c) 2024, Zumper
 * @description   MLS bizos
 */

import { Bizo, autoclass } from './base'
import type {
  MlsCompany as MlsCompanyType,
  MlsListing as MlsListingType,
  RawMlsCompany,
  RawMlsListing,
} from './mls.types'

export const MlsCompany: typeof MlsCompanyType = autoclass<MlsCompanyType, RawMlsCompany>(
  'MlsCompany',
  class MlsCompany extends Bizo<MlsCompanyType, RawMlsCompany> {},
  {
    associationName: 'association_name',
    createdOn: 'created_on',
    mlsCompanyId: 'mls_company_id',
    modifiedOn: 'modified_on',
    providerId: 'provider_id',
  }
)

export type MlsCompany = MlsCompanyType

export const MlsListing: typeof MlsListingType = autoclass<MlsListingType, RawMlsListing>(
  'MlsListing',
  class MlsListing extends Bizo<MlsListingType, RawMlsListing> {},
  {
    createdOn: 'created_on',
    mlsCompany: { name: 'mls_company', type: MlsCompany },
    mlsCompanyId: 'mls_company_id',
    mlsListingId: 'mls_listing_id',
    modifiedOn: 'modified_on',
    providerId: 'provider_id',
  }
)

export type MlsListing = MlsListingType
